import { useEffect, useState } from 'react'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PlanSuggestionsRecords = ({
  patientDBdata,
  diagnosisName,
  setPatientDBdata,
  noteID,
  
}) => {
   const [tempHtml, setTempHtml] = useState('')

  const planSuggestion =
    patientDBdata?.currentNote?.data?.plans?.[diagnosisName]?.planSuggestion

  // ⛔ Do nothing if no plan suggestions exist
  if (!diagnosisName || !planSuggestion || !planSuggestion.trim()) {
    return null
  }

  useEffect(() => {
    const savedHtml =
      patientDBdata?.currentNote?.data?.freeTypesEverything?.plans?.[diagnosisName]
        ?.planSuggestions

    const rawPlans = planSuggestion
      .split('\n')
      .map(p => p.trim())
      .filter(Boolean)

    const generatedHtml = `
      <div>
        ${rawPlans
          .map(
            plan => `
            <div style="margin-bottom:2px;">
              ${plan}
            </div>
          `
          )
          .join('')}
      </div>
    `

    const initialHtml = savedHtml || generatedHtml
    setTempHtml(initialHtml)

    // Save generated HTML only once if not already saved
    if (!savedHtml) {
      setPatientDBdata(prev => ({
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            freeTypesEverything: {
              ...prev.currentNote.data?.freeTypesEverything,
              plans: {
                ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
                [diagnosisName]: {
                  ...prev.currentNote.data?.freeTypesEverything?.plans?.[diagnosisName],
                  planSuggestions: generatedHtml,
                },
              },
            },
          },
        },
      }))
    }
  }, [diagnosisName, planSuggestion])

  const handleBlur = () => {
    setPatientDBdata(prev => ({
      ...prev,
      currentNote: {
        ...prev.currentNote,
        data: {
          ...prev.currentNote.data,
          freeTypesEverything: {
            ...prev.currentNote.data?.freeTypesEverything,
            plans: {
              ...(prev.currentNote.data?.freeTypesEverything?.plans || {}),
              [diagnosisName]: {
                ...prev.currentNote.data?.freeTypesEverything?.plans?.[diagnosisName],
                planSuggestions: tempHtml,
              },
            },
          },
        },
      },

      allNotes: prev.allNotes?.map(note => {
        if (note.id !== noteID) return note

        const parsedData = note.data ? JSON.parse(note.data) : {}

        return {
          ...note,
          data: JSON.stringify({
            ...parsedData,
            freeTypesEverything: {
              ...parsedData.freeTypesEverything,
              plans: {
                ...(parsedData.freeTypesEverything?.plans || {}),
                [diagnosisName]: {
                  ...parsedData.freeTypesEverything?.plans?.[diagnosisName],
                  planSuggestions: tempHtml,
                },
              },
            },
          }),
        }
      }),
    }))
  }

  return (
    <div className="w-100 my-4">
      <div style={{ width: '30%' }}>Plan Suggestion</div>

      <Editor
        value={tempHtml}
        onChange={e => setTempHtml(e.target.value)}
        onBlur={handleBlur}
        containerProps={{
          style: {
            width: '100%',
            background: '#2D2D2D',
            color: 'white',
            border: 0,
          },
        }}
      >
        <Toolbar hidden />
      </Editor>
    </div>
  )
}

export default PlanSuggestionsRecords
